import BlockUtilsMixin from '@intercom/embercom-composer/components/mixins/block-utils';
import { retryWithBackoff } from '@intercom/embercom-composer/lib/backoff';
import platform from '@intercom/embercom-composer/lib/platform';
import { normalizeEvent } from '@intercom/embercom-composer/lib/normalize-event';
import $ from 'jquery';
import { bind, next } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create(BlockUtilsMixin, {
  offscreenDivSelector: '.composer-offscreen',
  useOffscreenPaste: Em.computed(function () {
    return platform.get('needsOffscreenPaste');
  }),
  pastePlain(string) {
    let singleBlock = this.get('config.singleBlock');
    this.get('composerState').paste(string, {
      type: 'plain',
      singleBlock
    });
    this.updateDomAndSelection();
  },
  pasteHtml(string) {
    let singleBlock = this.get('config.singleBlock');
    this.get('composerState').paste(string, {
      type: 'html',
      singleBlock
    });
    this.updateDomAndSelection();
    this.scrollToSelection();
  },
  isBlockSelected() {
    return $('.block-is-current', this.element).length > 0;
  },
  paste(event) {
    let nativeEvent = normalizeEvent(event);
    let html = '';
    let plain = '';
    let plainMimeType = 'text/plain';
    try {
      this.syncCurrentBlock();
      if (this._needsPasteFallback(nativeEvent)) {
        html = this._getPastedFallbackContent().then(bind(this, this._pasteContent));
      } else {
        nativeEvent.preventDefault();
        let clipboardData = nativeEvent.clipboardData || window.clipboardData;
        if (this._isIEPaste()) {
          plainMimeType = 'Text';
        }
        if (!clipboardData) {
          return;
        }
        if (this.get('config.allowFilePaste') && this._hasFile(clipboardData)) {
          let file = this._getPastedFile(clipboardData);
          this.insertFiles([file]);
          return;
        }
        plain = clipboardData.getData(plainMimeType);
        if (!this._isIEPaste() && !platform.get('isEdge')) {
          html = clipboardData.getData('text/html');
        }
        this._pasteContent(html, plain);
      }
    } catch (error) {
      error.pastedContent = html || plain;
      this.sendError(error);
    }
  },
  _pasteContent(html, plain) {
    if (html) {
      this.pasteHtml(html);
    } else if (plain) {
      this.pastePlain(plain);
    }
  },
  _isIEPaste() {
    return window.clipboardData;
  },
  _getPastedFile(clipboardData) {
    let items = clipboardData.items || clipboardData.files;
    if (items[0].getAsFile) {
      return items[0].getAsFile();
    }
    return items[0];
  },
  _hasFile(clipboardData) {
    let allowedFileTypes = this.get('config.allowedImageTypes');
    let items = clipboardData.items || clipboardData.files;
    return items && items[0] && allowedFileTypes.includes(items[0].type);
  },
  cut() {
    let composerState = this.get('composerState');
    let uiSelection = this.get('uiSelection');
    try {
      composerState.syncLock();
      this.syncCurrentBlock();
      if (this.isBlockSelected()) {
        uiSelection.selectCurrentBlockForCopy(this.get('$editor'));
      }
    } catch (error) {
      this.sendError(error);
    }
    next(this, function () {
      try {
        uiSelection.removeCopyBoundry(this.get('$editor'));
        composerState.cut();
        this.updateDomAndSelection();
      } catch (error) {
        this.sendError(error);
      } finally {
        composerState.syncUnlock();
      }
    });
  },
  copy() {
    if (this.isBlockSelected()) {
      try {
        this.get('uiSelection').selectCurrentBlockForCopy(this.get('$editor'));
      } catch (error) {
        this.sendError(error);
      }
      next(this, function () {
        try {
          this.get('uiSelection').removeCopyBoundry(this.get('$editor'));
          this.updateDomAndSelection();
        } catch (error) {
          this.sendError(error);
        }
      });
    }
  },
  redirectPasteToOffscreenDiv() {
    let div = document.createElement('div');
    div.className = this.get('offscreenDivSelector').substring(1);
    div.setAttribute('contenteditable', 'true');
    // eslint-disable-next-line jquery-unsafe/no-append
    $(this.element).parent().append(div);
    this._moveSelectionToOffscreenDiv(div);
    this._triggerEmberPasteEvent();
  },
  _getPastedFallbackContent() {
    let $offscreenDiv = $(this.get('offscreenDivSelector'));
    return retryWithBackoff(function () {
      return new Em.RSVP.Promise(function (resolve, reject) {
        let html = $offscreenDiv.html();
        if ($offscreenDiv.html().length && $offscreenDiv.html() !== '<br>') {
          $offscreenDiv.remove();
          if (html.match(/webkit-fake-url/)) {
            reject();
          }
          resolve(html);
        } else {
          reject();
        }
      });
    }, 5, 2);
  },
  _isUsingPasteFallback() {
    let $currentSelectedElement = $(this.get('uiSelection.domSelection').getSelectionElement());
    return $currentSelectedElement.closest(this.get('offscreenDivSelector')).length;
  },
  _needsPasteFallback(event) {
    let clipboardData = event && event.clipboardData || window.clipboardData;
    if (!clipboardData) {
      return true;
    }
    if (this._hasFile(clipboardData)) {
      $(this.get('offscreenDivSelector')).remove();
      return false;
    }
    return this._isUsingPasteFallback();
  },
  _moveSelectionToOffscreenDiv(node) {
    this.get('uiSelection').setDomSelection(node, 0);
  },
  _triggerEmberPasteEvent() {
    $(this.element).trigger('paste');
  }
});